import { Card, CardContent, Skeleton } from 'lift-ui';
import type { Overview } from '../types';
import { formatCount } from '../utils';
import { STATUS_LABEL } from './JobStatusBadge';

interface OverviewCardsProps {
  overview: Overview | undefined;
  isLoading: boolean;
}

export const OverviewCards = ({ overview, isLoading }: OverviewCardsProps) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} className="h-20 w-full" />
        ))}
      </div>
    );
  }

  if (!overview) return null;

  const cards = overview.features.supported_statuses.map((status) => ({
    label: STATUS_LABEL[status],
    value: overview.statuses[status],
    highlight: status === 'failed' && (overview.statuses.failed ?? 0) > 0,
  }));

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
      {cards.map((card) => (
        <Card key={card.label}>
          <CardContent className="flex flex-col gap-1 p-4">
            <span className="text-xs uppercase tracking-wide text-muted-foreground">
              {card.label}
            </span>
            <span
              className={`text-2xl font-semibold ${card.highlight ? 'text-destructive' : ''}`}
            >
              {formatCount(card.value)}
            </span>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default OverviewCards;
